angular.module('mtic.components.modules.generalModuleMap').
directive('lmapBottomPanelGeneral', function(
  $log,
  language,
  EventManager,
  DEV_VARIABLES,
  TeacherDataService,
  ModuleFilter,
  MapStateService
) {
  return {

    templateUrl: 'template.html',
    scope: {
      'moduleMapData': '=',
    },

    link: function(scope, element) {
      scope.highlightedResource = {};
      scope.activeResource = {};
      var eventManager = new EventManager('lmapBottomPanel', scope)
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function(){
        if(activeAgenda.force_unlock === true) {
          return 'unlock';
        }
        else if(activeAgenda.force_unlock === false) {
          return 'lock';
        }
        else {
          return 'default';
        }
      }
      scope.itemIsLocked = function(){
        var isLocked = scope.highlightedResource.locked;
        if(activeAgenda && activeAgenda.resources && !(scope.highlightedResource.config && scope.highlightedResource.config.assessment_type && scope.highlightedResource.complete) && activeAgenda.resources.indexOf(scope.highlightedResource.id) > -1) {
          switch(interpeteAgendaLockStatus()) {
            case 'unlock':  return false;
            case 'lock':    return isLocked;
          }
        }
        return isLocked;
      }
      scope.itemClickedTeacherCheck = function() {
        if (TeacherDataService.isTeacherModuleView){
          scope.itemClicked();
        }
      }
      scope.itemClicked = function() {
        if(!ModuleFilter.checkAvailable(scope.highlightedResource)){
          scope.highlightedResource.locked = true;
          eventManager.broadcast('display-maintenance-message', scope.highlightedResource.slug);
          return;
        }
        if(!scope.itemIsLocked() || TeacherDataService.isTeacherModuleView){
          eventManager.broadcast('module:open:resource', scope.highlightedResource);
        }
      }
      scope.dismissClicked = function() {
        eventManager.broadcast('module:dismiss:focus');
      }
      scope.isCustomResource = function(){
        return scope.highlightedResource.resource_type === 'custom_resource';
      }
      eventManager.listen('module:select:resource', function(e, resource) {
        $log.log('from bottom panel : ' , resource)
        if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.slug) > -1 ||  (resource.config && resource.config.hidden===true)){
          return;
        }

        scope.activeResource = resource;

        if (scope.moduleMapData === undefined || !scope.moduleMapData.children){
          return;
        }
        var item_info = null;
        // $log.log('select resource : ', resource, scope.moduleMapData)
        for (var i = 0; i < scope.moduleMapData.children.length; i ++){
          if (scope.moduleMapData.children[i].slug === resource.slug){
            item_info = scope.moduleMapData.children[i];
            break;
          }
        }
        //If this item is already focused on, open it
        
        if (scope.highlightedResource && !TeacherDataService.isTeacherWorkspaceView && (scope.highlightedResource.slug === item_info.slug || (resource.map_config && resource.map_config.single_click_open)) && (item_info.locked === false || (scope.highlightedResource.config && scope.highlightedResource.config.assessment_type === 'summative' && !scope.itemIsLocked()))) {
          eventManager.broadcast('module:open:resource', resource);
          return;
        }
        else  {
          scope.highlightedResource = item_info;
        }
      })
      eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
        activeAgenda = agenda;
      })
      eventManager.listen('module:dismiss:focus', function(e, data) {
        scope.highlightedResource = {};
      })

      scope.getTranslation = function(slug){
        var caption = language.get(slug);
        if (!caption){
          caption = slug
        }
        return caption;
      }

      scope.getCompleteStarCount = function(){
        var resource = scope.highlightedResource;
        if (resource.resourceState)
        {
          if(resource.display.color === 'blue'){
            return Math.floor(resource.resourceState.score_max);
          }
          if(resource.resourceState.score_max >= 1){
            return 3;
          }else if(resource.resourceState.score_max >= 0.8){
            return 2;
          }else if(resource.resourceState.score_max >= 0.5){
            return 1;
          }
          return 0
        } else {
          return 0;
        }
      }

      scope.getMaxStarCount = function() {
        var resource = scope.highlightedResource;
        if (resource){
          if (resource.resource_type === "assessment"){
              // console.log('getMaxStarCount', 3)
              return 0;
          }
          else if (resource.display){
            if (resource.display.color === 'blue'){
              // console.log('getMaxStarCount', 1)
              return 1;
            }
            else {
              // console.log('getMaxStarCount', 3)
              return 3;
            }
          }
        }
        // console.log('getMaxStarCount', '0 (default)')
        return 0;
      }

      scope.getName = function(){
        var resource = scope.highlightedResource;
        var name;
        var resourceSlug = resource.slug;
        if(!resourceSlug || resourceSlug === 'run_like_math' || resourceSlug.indexOf('run_like_math') === -1 || resourceSlug.indexOf('lv_') === -1){
          name = language.get(resourceSlug)
        }else{
          var splt = resourceSlug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = resourceSlug.replace('_'+level, '');
          name = language.get(trans_slug)+ ' ' + level;
        }
        if (!name){
          if(resource.name) {
            name = resource.name;
          }else{
            name = resource.slug
          }
        }
        return name;
      }

      scope.isLeaderboardAvailable = function(){
        // $log.log('isLeaderboardAvailable', MapStateService.isLeaderboardAvailable)
        return MapStateService.isLeaderboardAvailable;
      }

      eventManager.listen('language:change', function() {
        $log.debug(scope.highlightedResource);
      })

      scope.hasActiveItem = function(){
        return true && scope.highlightedResource && scope.highlightedResource.name;
      }
      scope.$watch('moduleMapData', function(){
        if (scope.moduleMapData === undefined)
        {
          return;
        }

        // $log.log('MMD : ', scope.moduleMapData)

        if (scope.activeResource !== undefined)
        {
          var item_info = null;
          if (scope.moduleMapData.children)
          {
            for (var i = 0; i < scope.moduleMapData.children.length; i ++)
            {
              if (scope.moduleMapData.children[i].slug === scope.activeResource.slug)
              {
                scope.highlightedResource = scope.moduleMapData.children[i];
                return;
              }
            }
          }
        }
      })
       scope.$on('$destroy', function() {
        eventManager.broadcast('module:dismiss:focus');
      });
    }
  }
});
